export const formatToKPlus = (quantity: number): string => {
    if (quantity >= 1000) {
        let formattedQuantity = (quantity / 1000).toFixed(1);

        // 如果結果是以 ".0" 結尾，就轉換成整數
        if (formattedQuantity.endsWith('.0')) {
            formattedQuantity = parseInt(formattedQuantity).toString();
        }

        return `${formattedQuantity}K+`;
    }
    return quantity.toString();
};
